exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3xNvqAU8UxqyuPbaYRYvx7{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._3xNvqAU8UxqyuPbaYRYvx7{margin-top:0}", ""]);

// exports
exports.locals = {
	"description": "_3xNvqAU8UxqyuPbaYRYvx7"
};